import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFiltersInPage } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { ActivityCodesFilter } from 'components/common/GlobalFiltersInPage/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFiltersInPage/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { ResourceFilter } from 'components/common/GlobalFiltersInPage/components/ResourceFilter/resourceFilter';
import { TagsFilter } from 'components/common/GlobalFiltersInPage/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { DateRangeFilter } from 'components/common/GlobalFiltersInPage/components/dateRangeFilter/dateRangeFilter';
import { QuickAnswerFilter } from 'components/common/GlobalFiltersInPage/components/quickAnswerFilter/quickAnswerFilter';
import { ResourceTypeFilter } from 'components/common/GlobalFiltersInPage/components/resourceTypeFilter/ResourceTypeFilter';
import { GlobalFilterFieldKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { ResourcesAnalysisChart } from 'components/widgets/ResourcesAnalysisChart/ResourcesAnalysisChart';
import { ResourcesAnalysisTable } from 'components/widgets/resourcesAnalysisTable/resourcesAnalysisTable';

export const ResourcesAnalysisPage = () => {
    useFullStoryPageView({ pageName: executionConfig.resourcesAnalysis.title });
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton
                                title={executionConfig.resourcesAnalysis.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                            <VersionCompareSelectorWrapper allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.resourcesAnalysis.title} />
                    <GlobalFiltersInPage
                        defaultValues={{
                            [GlobalFilterFieldKey.dateRangeFilter]: 'R_4W',
                            [GlobalFilterFieldKey.quickAnswerFilter]: null,
                            [GlobalFilterFieldKey.resourceType]: null,
                            [GlobalFilterFieldKey.resource]: null,
                            [GlobalFilterFieldKey.milestoneFragnet]: null,
                            [GlobalFilterFieldKey.tags]: [],
                            [GlobalFilterFieldKey.activityCodes]: [],
                            [GlobalFilterFieldKey.wbs]: null,
                        }}
                    >
                        <DateRangeFilter name={GlobalFilterFieldKey.dateRangeFilter} />
                        <QuickAnswerFilter name={GlobalFilterFieldKey.quickAnswerFilter} />
                        <ResourceTypeFilter name={GlobalFilterFieldKey.resourceType} />
                        <ResourceFilter name={GlobalFilterFieldKey.resource} />
                        <MilestoneFragnetFilter name={GlobalFilterFieldKey.milestoneFragnet} />
                        <TagsFilter name={GlobalFilterFieldKey.tags} />
                        <ActivityCodesFilter name={GlobalFilterFieldKey.activityCodes} />
                        <WbsFilter name={GlobalFilterFieldKey.wbs} />
                    </GlobalFiltersInPage>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ResourcesAnalysisChart />
                    <ResourcesAnalysisTable />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['getResourceTable', 'getResourceChart', 'getStoredTags']} />
        </PageContainer>
    );
};
